// Colorblind-accessible palette (WCAG 1.4.1).
// Organized into hue families with strong luminance variation so that
// similar hues remain distinguishable under deuteranopia / protanopia / tritanopia.
const fills = [
    // Blues (3) — universally safe for all CVD types
    '#003F88', // deep navy
    '#1E88E5', // medium blue
    '#64B5F6', // light blue

    // Teals / Cyans (3)
    '#00695C', // dark teal
    '#00ACC1', // medium cyan
    '#80DEEA', // light cyan

    // Purples / Violets (4)
    '#4A148C', // deep purple
    '#7B1FA2', // dark purple
    '#AB47BC', // medium purple
    '#CE93D8', // light purple

    // Magentas / Pinks (3)
    '#880E4F', // dark magenta
    '#E91E63', // medium pink
    '#F48FB1', // light pink

    // Oranges (4) — safe for all CVD types; vary strongly in lightness
    '#BF360C', // dark burnt orange
    '#F4511E', // deep orange
    '#FF7043', // medium orange
    '#FFAB91', // light orange / salmon

    // Ambers (2)
    '#F57F17', // dark amber
    '#FFD54F', // light amber

    // Reds (2) — differentiated from oranges by distinct lightness steps
    '#B71C1C', // dark red
    '#EF9A9A', // light coral

    // Greens (4) — wide luminance spread so shades stay distinct
    '#1B5E20', // very dark green
    '#388E3C', // dark green
    '#66BB6A', // medium green
    '#A5D6A7', // light green

    // Blue-Greys / Neutrals (3)
    '#263238', // near-black blue-grey
    '#546E7A', // dark blue-grey
    '#90A4AE', // light blue-grey

    // Browns (2)
    '#5D4037', // dark brown
    '#A1887F', // light brown
];

const strokes = fills.map(hex => {
    // Darken each fill by reducing brightness for the stroke
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const darken = (c) => Math.max(0, Math.floor(c * 0.65)).toString(16).padStart(2, '0');
    return `#${darken(r)}${darken(g)}${darken(b)}`;
});

export const chartTheme = {
    baseTheme: 'ag-default',
    palette: {
        fills,
        strokes,
    },
};
